import LArtwork from "@components/LArtwork";
import LBox from "@components/LBox";
import LText from "@components/LText";
import { fonts } from "@theme";
import { InboxSectionCta, SectionText, SectionTitle } from "../shared";
import type { ArtistSupportPayload, InboxSection, OnNavigate } from "../types";

const AVATAR_SIZE = 48;
const AVATAR_OVERLAP = 16;

/**
 * "Artists you support" — an overlapping avatar stack + name list + copy + CTA,
 * mirroring the artist_support block of the weekly-digest email.
 */
export const ArtistSupportSection = ({
  section,
  onNavigate,
}: {
  section: InboxSection;
  onNavigate: OnNavigate;
}) => {
  const { artists } = section.payload as ArtistSupportPayload;
  const nameList = artists.map((a) => a.name).join(", ");

  return (
    <LBox gap="s3_5">
      <SectionTitle>{section.title}</SectionTitle>

      <LBox gap="s3">
        <LBox flexDirection="row" alignItems="center">
          {artists.map((artist, index) => (
            <LArtwork
              key={artist.id}
              borderColor="white"
              borderRadius="max"
              borderWidth={2}
              size={AVATAR_SIZE}
              style={{ marginLeft: index === 0 ? 0 : -AVATAR_OVERLAP }}
              url={artist.image}
              userAvatar
            />
          ))}
          {nameList ? (
            <LText
              color="white"
              fontFamily={fonts.semiBold}
              fontSize={14}
              lineHeight={20}
              numberOfLines={2}
              style={{ flex: 1, marginLeft: 12 }}
            >
              {nameList} and more
            </LText>
          ) : null}
        </LBox>

        <SectionText>{section.text}</SectionText>
      </LBox>

      {section.ctaUrl ? (
        <InboxSectionCta
          label={section.ctaText}
          onPress={() => onNavigate(section.ctaUrl)}
        />
      ) : null}
    </LBox>
  );
};
